module.exports = __webpack_public_path__ + "static/img/xi_1.4f0b0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_1.jpg
// module id = LLjp
// module chunks = 1